import React, { FC } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { RootState } from '../../../../setup';
import * as auth from '../../../redux/AuthRedux';
import { IAuthState } from '../../auth';
import { parseJwt } from '../../../views/login/Login';
import { logout } from '../../../redux/AuthCRUD';
import { BASE_URL } from '../../../../config/environmentConfig';
import { copyTextToClipboard } from '../../../utils/utilities';
import { toaster } from 'rsuite';
import toastMessage from '../../ToastMessage';
import { toAbsoluteUrl } from '../../../utils';
import { useTranslation } from 'react-i18next';
import { Title } from '../../developers/page-components/Title';
import { useLocation } from 'react-router';
import { APPLICATION_VIEW_BASE_VIEW } from '../../application-view/ApplicationViewAsideMenu';
import { checkRoles, CLAIMS } from '../../../utils/roles-helper';

import './HeaderUserMenu.scss';

const HeaderUserMenu: FC = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const user = parseJwt(authUser.idToken);
	const id = user?.['custom:mid'];

	const { t } = useTranslation();
	const { pathname } = useLocation();

	const handleClick = (value, text): void => {
		copyTextToClipboard(value);
		toaster.push(toastMessage({
			text: `${t(text)} was copied!`,
			type: 'success'
		}), { placement: 'topEnd' });
	};

	const onLogout = async (): Promise<void> => {
		try {
			await logout(authUser?.accessToken);
		} catch (e) {
			console.log('e', e);
		}
		console.log('logout---013');
		dispatch(auth.actions.logout());
		navigate('/');
	};

	return (
		<div
			className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
			data-kt-menu="true"
		>
			<div className="menu-item px-3"
				// onClick={() => history.push('/profile')}
			>
				<div className="menu-content d-flex align-items-center px-3">
					<div className="symbol symbol-50px me-5">
						{
							user?.icon ?
								(
									<img
										src={user?.icon}
										alt="Logo"
									/>
								) : (
									<span
										className="font-weight-bold bg-light-danger rounded-2 d-flex align-items-center justify-content-center user-icon">
										<span>{user?.given_name?.[0] || ''}</span>
										<span>{user?.family_name?.[0] || ''}</span>
									</span>
								)
						}
					</div>

					<div className="d-flex flex-column">
						<div className="fw-bolder d-flex align-items-center fs-5">
							{user?.given_name ?? ''} {user?.family_name ?? ''}
							<span className="badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2">Pro</span>
						</div>
						<div className="fw-bold text-muted text-hover-primary fs-7 text-wrap">
							{authUser.userData.email}
						</div>
					</div>
				</div>
			</div>

			{
				checkRoles(authUser, CLAIMS.MERCHANT_ADMIN) && !pathname.includes(APPLICATION_VIEW_BASE_VIEW) && (
					<>
						<div className="separator my-2" />

						<div className="menu-item px-5">
							<Title title="Merchant ID:" additionalClass="px-5 fw-bolder mb-1" />
							<div className="px-5 d-flex align-items-center">
								<div className="text-truncate">
									{id}
								</div>
								<div
									className="icon-copy cursor-pointer ms-2 pb-2"
									onClick={(): void => handleClick(id, 'Merchant ID')}
									data-cy="user-profile-block"
								>
									<img src={toAbsoluteUrl('/media/icons/copy.svg')} width="12px" height="15px" alt="copy" />
								</div>
							</div>
						</div>
					</>
				)
			}

			{
				!pathname.includes(APPLICATION_VIEW_BASE_VIEW) && (
					<>
						<div className="separator my-2" />

						<div className="menu-item px-5">
							{/*TODO check partners permissions*/}
							{/*@ts-ignore*/}
							<Link to={checkRoles(authUser, CLAIMS.MERCHANT_ADMIN) ? '/user-settings/profile' : '/profile'}
							      className="menu-link px-5">
								{checkRoles(authUser, CLAIMS.MERCHANT_ADMIN) ? 'Profile and Settings': 'Profile'}
							</Link>
						</div>

					</>
				)
			}


			{/*<div className="menu-item px-5">*/}
			{/*	<a href="#" className="menu-link px-5">*/}
			{/*		<span className="menu-text">My Projects</span>*/}
			{/*		<span className="menu-badge">*/}
			{/*            <span className="badge badge-light-danger badge-circle fw-bolder fs-7">3</span>*/}
			{/*        </span>*/}
			{/*	</a>*/}
			{/*</div>*/}

			{/*<div*/}
			{/*	className="menu-item px-5"*/}
			{/*	data-kt-menu-trigger="hover"*/}
			{/*	data-kt-menu-placement="left-start"*/}
			{/*	data-kt-menu-flip="bottom"*/}
			{/*>*/}
			{/*	<a href="#" className="menu-link px-5">*/}
			{/*		<span className="menu-title">My Subscription</span>*/}
			{/*		<span className="menu-arrow"/>*/}
			{/*	</a>*/}

			{/*	<div className="menu-sub menu-sub-dropdown w-175px py-4">*/}
			{/*		<div className="menu-item px-3">*/}
			{/*			<a href="#" className="menu-link px-5">*/}
			{/*				Referrals*/}
			{/*			</a>*/}
			{/*		</div>*/}

			{/*		<div className="menu-item px-3">*/}
			{/*			<a href="#" className="menu-link px-5">*/}
			{/*				Billing*/}
			{/*			</a>*/}
			{/*		</div>*/}

			{/*		<div className="menu-item px-3">*/}
			{/*			<a href="#" className="menu-link px-5">*/}
			{/*				Payments*/}
			{/*			</a>*/}
			{/*		</div>*/}

			{/*		<div className="menu-item px-3">*/}
			{/*			<a href="#" className="menu-link d-flex flex-stack px-5">*/}
			{/*				Statements*/}
			{/*				<i*/}
			{/*					className="fas fa-exclamation-circle ms-2 fs-7"*/}
			{/*					data-bs-toggle="tooltip"*/}
			{/*					title="View your statements"*/}
			{/*				/>*/}
			{/*			</a>*/}
			{/*		</div>*/}

			{/*		<div className="separator my-2"/>*/}

			{/*		<div className="menu-item px-3">*/}
			{/*			<div className="menu-content px-3">*/}
			{/*				<label className="form-check form-switch form-check-custom form-check-solid">*/}
			{/*					<input*/}
			{/*						className="form-check-input w-30px h-20px"*/}
			{/*						type="checkbox"*/}
			{/*						value="1"*/}
			{/*						defaultChecked={true}*/}
			{/*						name="notifications"*/}
			{/*					/>*/}
			{/*					<span className="form-check-label text-muted fs-7">Notifications</span>*/}
			{/*				</label>*/}
			{/*			</div>*/}
			{/*		</div>*/}
			{/*	</div>*/}
			{/*</div>*/}

			{/*<div className="menu-item px-5">*/}
			{/*	<a href="#" className="menu-link px-5">*/}
			{/*		My Statements*/}
			{/*	</a>*/}
			{/*</div>*/}

			<div className="separator my-2"/>

			{/*<Languages/>*/}

			{/*<div className="menu-item px-5 my-1">*/}
			{/*	<Link to="/crafted/account/settings" className="menu-link px-5">*/}
			{/*		Account Settings*/}
			{/*	</Link>*/}
			{/*</div>*/}

			<div className="menu-item px-5 d-flex justify-content-between align-items-center">
				{
					checkRoles(authUser, CLAIMS.SUPER_ADMIN)
						? (
							<Link
								to="/release-notes"
								className="menu-link menu-version"
							>
								{BASE_URL.APP_VERSION}
							</Link>

						) : (
							<span className="px-5 menu-gray-600">{BASE_URL.APP_VERSION}</span>
						)

				}
				<a onClick={onLogout} className="menu-link menu-sing-out">
					Sign out
				</a>
			</div>
		</div>
	);
};

export { HeaderUserMenu };
